import { clientDb } from '../../../shared/firebase'
import { getOrganizationExtraInfo } from '../../../shared/db/extra-info-db'
import { ExtraInfoFields } from '../../../shared/interfaces'

export const getAssignee = async (deviceId: string): Promise<string> => {
  try {
    const extraInfoMap = await getOrganizationExtraInfo()
    const assigneeKey = extraInfoMap[ExtraInfoFields.ASSIGNEE]

    if (!assigneeKey) return ''

    const snapshot = await clientDb()
      .child(`/devices/device-details/${deviceId}/extra-info/${assigneeKey}`)
      .once('value')

    return snapshot.val()?.text || ''
  } catch (error) {
    console.error('Failed to fetch assignee:', error)
    return ''
  }
}